import React from 'react';
import { useHistory } from 'react-router-dom';
import { ActiveCollections } from './activeCollections';
import { TabButtons } from 'components';
import { tabEnums, tabParams } from './constants';
import { CollectionsHistory } from './collectionsHistory';

export const Collections = ({}) => {
  const history = useHistory();
  const info = history?.location?.state;

  return (
    <div>
      <TabButtons tabParams={tabParams} />
      {info?.viewType === tabEnums?.HISTORY ?
        <CollectionsHistory />
        :
        <ActiveCollections />
      }
    </div>
  );
};